import { createFileRoute } from "@tanstack/react-router";
import { GuardAccessPage } from "@/components/pages/GuardAccessPage";

export const Route = createFileRoute("/guard/")({
  component: GuardAccessPage,
});
